import httpClient from './httpClient';

const END_POINT = '/pcs';
const mapAuthHeader = (token, opts = {}) => ((token) ? {
  headers: {
    Authorization: `Bearer ${token}`,
    ...opts,
  },
} : {});

const listProfitCenters = (token, scope = 'defaultScope') => httpClient.get(`${END_POINT}?${new URLSearchParams({ scope }).toString()}`, {
  ...mapAuthHeader(token),
});

const createProfitCenter = (pc, token) => httpClient.post(END_POINT, pc, {
  ...mapAuthHeader(token),
});

const getProfitCenter = (id, token) => httpClient.get(`${END_POINT}/${id}`, {
  ...mapAuthHeader(token),
});

const updateProfitCenter = (id, pc, token) => httpClient.put(`${END_POINT}/${id}`, pc, {
  ...mapAuthHeader(token),
});

const deleteProfitCenter = (id, token) => httpClient.delete(`${END_POINT}/${id}`, {
  ...mapAuthHeader(token),
});

export {
  listProfitCenters,
  createProfitCenter,
  getProfitCenter,
  updateProfitCenter,
  deleteProfitCenter,
};
